var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-link';
                    var viewUrl = 'sprite.svg#view-icon-link';

                    
                        var addCacheBust = typeof document !== 'undefined' && document.readyState === 'complete';
    
                        if (addCacheBust) {
                            symbolUrl = 'sprite.svg?icon-link#icon-link';
                            viewUrl = 'sprite.svg?icon-link#view-icon-link';
                        }
                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };